import { render, staticRenderFns } from "./CatalogCartDrawer.vue?vue&type=template&id=5612fe64&scoped=true&"
import script from "./CatalogCartDrawer.vue?vue&type=script&lang=js&"
export * from "./CatalogCartDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CatalogCartDrawer.vue?vue&type=style&index=0&id=5612fe64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5612fe64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VIcon,VNavigationDrawer})
